import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import Utilis from '../../../../Models/Utilis';
import DistantProfils from '../../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import Hash from '../../../../Functions/Security/Hash';
import { Typography } from '@mui/material';
import Tab4 from './Tab4';
import Params from '../../../../Types/ParamsPicklist';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Pret from '../../../../Models/Pret';
import Garantie from '../../../../Models/Garantie';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RELATION from '../../../../Models/Relation';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import CouvertureDate from '../../../../Functions/Traitement/CouvertureDate';
import formatOrderDate from '../../../../Functions/Traitement/formatOrderDate';
import HelpInfos from '../../../HelpInfo';
//import "../../Assets/Styles/StyleForm.css";
import HelpData from "../../../../Data/Help.json"
import Help from '../../../../Types/Help';



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const DemandePret = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")

  
  const navigate = useNavigate()

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    localStorage.setItem(Data.LocalVariable.reset, '0')
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
    localStorage.setItem(Data.LocalVariable.garantie, "")
    localStorage.setItem(Data.LocalVariable.avaliste, "")
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
    setImpActive(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Demande
        </span>
      ),
      children: <Tab1 form={form} disabled={ajoutActve} />,
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <ContactsOutlined />
          Garanties
        </span>
      ),

      children: <Tab2 />,
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined />
          Avaliste
        </span>
      ),
      children: <Tab3 form={form} />,
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined />
          Commission
        </span>
      ),
      children: <Tab4 form={form} />,
    },
  ];

  const onFinish = (values: any) => {

    var garanties: Garantie[] = [];
    var avalistes: RELATION[] = [];
    var CodesGaranties: string[] = []
    var CodesAvalistes: string[] = []
    var montantCouvert: number = 0
    var messageGarantie = ""
    let verifDate = false

    let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, values.DAT1ECHE, values.cssionApliq)
        
    let derniereEch = Amort.GetAmortissement()[Amort.GetAmortissement().length-1].dateEcheacnce

    try {
      garanties = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.garantie) + "")) as []
      garanties.map((g: Garantie) => {
        CodesGaranties.push(g.codgar + "|" + g.valCouvert)

        //alert(CouvertureDate(ReformatDate(form.getFieldValue("DAT1ECHE")), derniereEch, ReformatDate(g.DATDEB+""), ReformatDate(g.DATFIN+"")))
        if(CouvertureDate(ReformatDate(form.getFieldValue("DAT1ECHE")), derniereEch, ReformatDate(g.DATDEB+""), ReformatDate(g.DATFIN+""))){
          verifDate = true
        }else{
          messageGarantie += 'La garantie '+g.codgar+' ('+g.TEXTCOMMEN+') ne couvre pas le prêt sur la période ['+formatOrderDate(ReformatDate(g.DATDEB), 'JJ-MM-AAAA')+', '+formatOrderDate(ReformatDate(g.DATFIN), 'JJ-MM-AAAA')+']\n\n'
        }

      })
    } catch (error) {
      verifDate = false
      CodesGaranties = []
    }

    try {
      avalistes = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.avaliste) + ""))
      avalistes.map((r: RELATION) => {
        CodesAvalistes.push(r.NumRel)
      })
    } catch (error) {
      CodesAvalistes = []
    }
    try {
      montantCouvert = JSON.parse(localStorage.getItem(Data.LocalVariable.montantGarantieCouvert) + "")
    } catch (error) {}

    if(verifDate){
      if (parseInt(form.getFieldValue("MONTAN")) <= montantCouvert && montantCouvert != 0) {
        if (CodesGaranties.length != 0) {
          if (sbmit == "add") {
            SweetAlert.fire({
              title: "Voulez-vous enregistrer la demande de pret de\n" + values.lib_NUMCLI + "\ndu montant de\n" + formatNumber(values.MONTAN) + " XAF ?",
              showCancelButton: true,
              color: "green",
              confirmButtonText: "Yes",
              confirmButtonColor: "green",
              cancelButtonColor: "darkred",
              cancelButtonText: "No",
              showLoaderOnConfirm: true,
              icon: 'question'
            }).then((res) => {
              if (res.isConfirmed) {
                try {
  
                  setLoading(true);
                  setIsSubmit(true)
                  var pret: Pret = { "UTILISAI": user.coduti, ...values, "garanties": CodesGaranties, "avalistes": CodesAvalistes }
                  pret.DATEDEM = formatDate(pret.DATEDEM)
                  pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
                  pret.NOMCLI = values.lib_NUMCLI
                  pret.CPTORDI = form.getFieldValue("CPTORDI")
                  pret.CPTEPARG = form.getFieldValue("CPTEPARG")
                  pret.AGCCPT = user.codage
                  pret.NUMDOS = ''
                  pret.step = 'demande'
                  pret.dateVal = ''
                  pret.DATACC = ''
                  pret.UTIAPP = ''
                  pret.UTIVAL = ''
  
                  let data = Crypter.encrypt(JSON.stringify(pret));
  
                  let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.CreatePret,
                    headers: {
                      'Authorization': authHeader(),
                      'Content-Type': 'application/json'
                    },
                    data: data,
                  };
  
                  axios.request(config)
                    .then((response) => {
                      setLoading(false);
                      if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                        if (res.StatutCode == 200) {
                          let code = pret.NUMDOS
                          form.resetFields()
                          localStorage.clear()
                          setIsSubmit(false)
                          SweetAlert.fire({ title: res.Message, icon: "success" })
                          initialiazeButton()
                          localStorage.setItem(Data.LocalVariable.reset, "1")
                          initialiazeButton()
                          setSbmit("")
                        }
                        else {
                          SweetAlert.fire({ title: res.Message, icon: "warning" })
                        }
                      }
                    })
                    .catch((error) => {
                      setLoading(false);
                      console.log(error)
                      SweetAlert.fire({ title: error, icon: "error" })
                    })
                } catch (error) {
                  SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
                }
              }
            })
          }
          if (sbmit == "update") {
            //console.log(values)
            SweetAlert.fire({
              title: "Voulez-vous modifier la demande de pret " + values.NUMDOS + " ?",
              showCancelButton: true,
              color: "green",
              confirmButtonText: "Yes",
              confirmButtonColor: "green",
              cancelButtonColor: "darkred",
              cancelButtonText: "No",
              showLoaderOnConfirm: true,
              icon: 'question'
            }).then((res) => {
              if (res.isConfirmed) {
                try {
                  setLoading(true);
                  setIsSubmit(true)
                  var pret: Pret = { "UTILISAI": user.coduti, ...values, "garanties": CodesGaranties, "avalistes": CodesAvalistes }
                  pret.DATEDEM = formatDate(pret.DATEDEM)
                  pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
                  pret.NOMCLI = values.lib_NUMCLI
                  pret.CPTORDI = form.getFieldValue("CPTORDI")
                  pret.CPTEPARG = form.getFieldValue("CPTEPARG")
                  pret.step = Data.LocalVariable.LoanStep.Demande
                  pret.CDETAT = form.getFieldValue("CDETAT")
  
  
                  console.log('Received values of form: ', JSON.stringify(pret));
  
                  let data = Crypter.encrypt(JSON.stringify(pret));
  
                  let config = {
                    method: 'put',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.UpdatePret,
                    headers: {
                      'Authorization': authHeader(),
                      'Content-Type': 'application/json'
                    },
                    data: data,
                  };
  
                  axios.request(config)
                    .then((response) => {
                      setLoading(false);
                      if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                        if (res.StatutCode == 200) {
                          let code = pret.NUMDOS
                          form.resetFields()
                          localStorage.clear()
                          setIsSubmit(false)
                          SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                          initialiazeButton()
                          localStorage.setItem(Data.LocalVariable.reset, "1")
                          initialiazeButton()
                          setSbmit("")
                        }
                        else {
                          SweetAlert.fire({ title: res.Message, icon: "warning" })
                        }
                      }
                    })
                    .catch((error) => {
                      setLoading(false);
                      console.log(error)
                      SweetAlert.fire({ title: error, icon: "error" })
                    })
                } catch (error) {
                  SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
                }
              }
            })
          }
        } else {
          SweetAlert.fire({ title: "Vous devez d'abord sélectionner les garanties de prêt avant d'enregistrer", icon: "warning" })
        }
      } else {
        SweetAlert.fire({ title: "La somme des montant couvert dois être supérieur ou égale au montant demandé", icon: "warning" })
      }
    }else{
      SweetAlert.fire({ title: messageGarantie, text: '\n Période du prêt : ['+formatOrderDate(ReformatDate(form.getFieldValue("DAT1ECHE")), 'JJ-MM-AAAA')+', '+formatOrderDate(ReformatDate(derniereEch), 'JJ-MM-AAAA')+']', icon: "warning" })
    }


  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NUMDOS") + "|" + Data.LocalVariable.LoanStep.Demande);
    let numdos = form.getFieldValue("NUMDOS")

    if (data.length != 0) {
      form.setFieldValue('garantie', '')
      form.setFieldValue('avaliste', '')
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NUMDOS', numdos)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetPret,
        headers: {
          'CipherNumDos': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table[0])
              form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
              form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
              //form.setFieldValue('', )

              localStorage.clear()

              localStorage.setItem(Data.LocalVariable.garantie, Crypter.encrypt(JSON.stringify(res.Result.Table1)))
              localStorage.setItem(Data.LocalVariable.avaliste, Crypter.encrypt(JSON.stringify(res.Result.Table2)))
              localStorage.setItem('numcli', Crypter.encrypt(JSON.stringify(res.Result.Table[0].NUMCLI)))

              localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(res.Result.Table3)))
              localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(res.Result.Table4)))

              localStorage.setItem('load_compte', "1")

              form.setFieldValue("cssionApliq", eval(res.Result.Table[0].MTNCOM1 + res.Result.Table[0].MTNCOM2 + res.Result.Table[0].MTNCOM3 + res.Result.Table[0].MTNCOM4 + res.Result.Table[0].MTNCOM5))
              console.log(JSON.stringify(res.Result.Table))


              initialiazeButton()

              cunsultButton()

              if(res.Result.Table[0].CDETAT != 60){
                SweetAlert.fire({ title: "Modification impossible sur cette demande de prêt", icon: "warning" })
                setModifActve(true)
              }

            }
            else {
              localStorage.removeItem(Data.LocalVariable.reset)
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }
  function modif() {

    modifButton()

    //let state = form.getFieldValue("CDETAT")
    // if(state == "60"){
    // }else{
    //   SweetAlert.fire({
    //     title: 'Attention',
    //     text: "Cette demande n'est plus modifiable. Déjà Proposé", 
    //     icon: 'warning'
    //   })
    // }
  }

  function printTab() {

  //  Génération de tableau d'amortissement
  //--------------------------/
      let values: any = form.getFieldsValue()

      let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, values.DAT1ECHE, values.cssionApliq)
      console.log(Amort)
  //--------------------------/

  //  Entête du tableau
  //-------------------------/
  const columns: ColumnsType<any> = [
    {
      title: 'N° Séq',
      dataIndex: 'numSeq',
      width: "100px"
    },
    {
      title: 'Date Echéance',
      dataIndex: 'dateEcheacnce',
      width: "100px"
    },
    {
      title: 'Capital (C)',
      dataIndex: 'capital',
      width: "100px"
    },
    {
      title: 'Amortiss (A)',
      dataIndex: 'amortissement',
      width: "100px"
    },
    // {
    //   title: 'Echéancier',
    //   dataIndex: 'echeancierSansTaxe',
    // },
    {
      title: 'Inttérets (I)',
      dataIndex: 'interet',
      width: "100px"
    },
    {
      title: 'Taxes (T)',
      dataIndex: 'taxe',
      width: "100px"
    },
    {
      title: 'Epargne (E)',
      dataIndex: 'epargne',
      width: "100px"
    },
    {
      title: 'AHT (A+I) ',
      dataIndex: 'anHT',
      width: "100px"
    },
    {
      title: 'ATTC (AHT+I) ',
      dataIndex: 'anTTC',
      width: "100px"
    }
  ];
  //------------------------------/

    var newData = []
    newData = (Amort.GetAmortissement() as []) as any

    newData.push({
      "numSeq": "",
      "dateEcheacnce": "",
      "capital": "",
      "amortissement": "",
      "interet": "",
      "taxe": "",
      "epargne": "",
      "anHT": "",
      "anTTC": ""
    })
    newData.push({
      "numSeq": "TOTAL ",
      "dateEcheacnce": "",
      "capital": "",
      "amortissement": Amortissement.totaux.TotAm,
      "interet": Amortissement.totaux.TotIt,
      "taxe": Amortissement.totaux.TotTaxe,
      "epargne": Amortissement.totaux.TotEpargn,
      "anHT": Amortissement.totaux.TotAnnuite,
      "anTTC": Amortissement.totaux.TotAnTTC,
    });
    
    localStorage.setItem(Data.LocalVariable.tabAmort, JSON.stringify({ "columns": columns, "data": newData, "form": {...form.getFieldsValue(), titre: "TABLEAU D'AMORTISSEMENT"+(form.getFieldValue("NUMDOS")?" N°"+form.getFieldValue("NUMDOS"): "")} }))

    navigate("/prets/simulation/print");
  }

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
            <HelpInfos helpInfo={HelpData.Pret.DemandeDePret as Help} />
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default DemandePret;